<template>
<div class="radial_gradient"></div>
</template>

<script>
export default {
  name: "RadialGradient"
}
</script>

<style scoped>
.radial_gradient{
  width: 200vw;
  height: 200vh;
  transform: translate(-50vw, -100vh);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  pointer-events: none;
  background: radial-gradient(50% 50% at 50% 50%,#fc077d10 0,rgba(255,255,255,0) 100%);
}
</style>